import * as React from "react";
import styles from "./Mc2ReadonlyCell.module.less";

type PropsMc2ReadonlyCell = {
  text: number | string | null | undefined;
};

export const Mc2ReadonlyCell: React.FC<PropsMc2ReadonlyCell> = ({ text }) => (
  <span className={styles.text}>{text}</span>
);
